import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { ChartSelector } from 'components/Molecules/ChartSelector'
import { LVG_GRAPH_OPTIONS } from 'constants/games/lvg/lvgGraphsOptions'
import { useUser, useUserUpdaters } from 'hooks/user/useUser'
import { UserPreferencesCSS } from './UserPreferencesCSS.styled'
import { useUserPreferencesData } from './useUserPreferencesData'

export const UserPreferences = () => {
  const { lastSelectedAssets, socialFeedPanel, defaultLvgGraphId } =
    useUser('preferences')
  const { updateUserPreferences } = useUserUpdaters()

  const {
    isPending: isEmailPending,
    data,
    updateData,
  } = useUserPreferencesData()

  const checkBoxChange = (e) => {
    const key = e.target?.name
    const value = e.target?.checked
    updateUserPreferences({ [key]: value })
  }
  const emailCheckBoxChange = (e) => {
    const key = e.target?.name
    const value = e.target?.checked
    updateData({ [key]: value })
  }

  const selectGraphType = (option) => {
    updateUserPreferences({ defaultLvgGraphId: option.id })
  }

  return (
    <UserPreferencesCSS>
      <div className='content column'>
        <div className='subtitle'>PREFERENCES</div>
        <div className='grid-content prefs'>
          {/* <!-- ROW --> */}
          <label className='title'>
            Default asset selection to last selected asset and graph type
          </label>
          <label className='value'>
            <input
              type='checkbox'
              name='lastSelectedAssets'
              checked={lastSelectedAssets}
              onChange={checkBoxChange}
            />
          </label>
          {/* <!-- ROW --> */}
          <label className='title'>
            Open the Social Feed (chat) by default
          </label>
          <label className='value'>
            <input
              type='checkbox'
              name='socialFeedPanel'
              checked={socialFeedPanel}
              onChange={checkBoxChange}
            />
          </label>
          {/* <!-- ROW --> */}
          <label className='title'>Default graph type</label>
          <label className='value'>
            <div className='select_menu'>
              <div className='select-box'>
                <ChartSelector
                  options={LVG_GRAPH_OPTIONS.slice(0, 6)}
                  selectedOption={LVG_GRAPH_OPTIONS[defaultLvgGraphId]}
                  onSelect={selectGraphType}
                  noBadge={false}
                />
              </div>
            </div>
          </label>
        </div>
      </div>
      <div className='content column'>
        <div className='subtitle'>SEND AN EMAIL WHEN...</div>
        <div className='grid-content email'>
          {/* <!-- ROW --> */}
          <label className='title'>A bid is placed</label>
          <label className='value'>
            <SingleDataLoader
              loading={
                isEmailPending === 'all' || isEmailPending === 'openOrderEmail'
              }
              data={
                <input
                  type='checkbox'
                  name='openOrderEmail'
                  checked={data?.openOrderEmail}
                  onChange={emailCheckBoxChange}
                />
              }
            />
          </label>

          {/* <!-- ROW --> */}
          <label className='title'>An order has updated</label>
          <label className='value'>
            <SingleDataLoader
              loading={
                isEmailPending === 'all' || isEmailPending === 'updateEmails'
              }
              data={
                <input
                  type='checkbox'
                  name='updateEmails'
                  checked={data?.updateEmails}
                  onChange={emailCheckBoxChange}
                />
              }
            />
          </label>
          {/* <!-- ROW --> */}
          <label className='title'> An order has closed </label>
          <label className='value'>
            <SingleDataLoader
              loading={
                isEmailPending === 'all' ||
                isEmailPending === 'closedOrderEmail'
              }
              data={
                <input
                  type='checkbox'
                  name='closedOrderEmail'
                  checked={data?.closedOrderEmail}
                  onChange={emailCheckBoxChange}
                />
              }
            />
          </label>
          {/* <!-- ROW --> */}
          <label className='title'>An order has busted</label>
          <label className='value'>
            <SingleDataLoader
              loading={
                isEmailPending === 'all' ||
                isEmailPending === 'bustedOrderEmail'
              }
              data={
                <input
                  type='checkbox'
                  name='bustedOrderEmail'
                  checked={data?.bustedOrderEmail}
                  onChange={emailCheckBoxChange}
                />
              }
            />
          </label>
        </div>
      </div>
    </UserPreferencesCSS>
  )
}
